import { render, staticRenderFns } from "./TowelReservation.vue?vue&type=template&id=24bc7a6c&scoped=true"
import script from "./TowelReservation.vue?vue&type=script&lang=js"
export * from "./TowelReservation.vue?vue&type=script&lang=js"
import style0 from "./TowelReservation.vue?vue&type=style&index=0&id=24bc7a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc7a6c",
  null
  
)

export default component.exports